// src/utils/phone.js

/**
 * Normalize Ethiopian mobile numbers to E.164 format: +2517XXXXXXXX or +2519XXXXXXXX
 * Accepts:
 *  - +2517/9XXXXXXXX
 *  - 2517/9XXXXXXXX
 *  - 07/7XXXXXXXX
 *  - 09/9XXXXXXXX
 *
 * Returns: { ok: boolean, value?: string, error?: string }
 */
export function normalizeEthiopianMobile(input) {
  const raw = String(input ?? "").trim();
  const digits = raw.replace(/\D/g, "");

  if (digits.length < 9) {
    return { ok: false, error: "minimum length of phone is 9" };
  }

  let normalized = null;

  // Match 07xxxxxxx, 09xxxxxxx, 7xxxxxxx, 9xxxxxxx  →  +251[7/9]xxxxxxxx
  if (/^(?:0?[79])\d{8}$/.test(digits)) {
    normalized = "+251" + digits.replace(/^0?/, "");
  }
  // Match 2517xxxxxxx or 2519xxxxxxx → +251[7/9]xxxxxxxx
  else if (/^251[79]\d{8}$/.test(digits)) {
    normalized = "+" + digits;
  }
  // Match already normalized +2517xxxxxxx or +2519xxxxxxx (with optional spaces/dashes)
  else if (/^\+?251[79]\d{8}$/.test(raw.replace(/\s|-/g, ""))) {
    normalized = raw.startsWith("+")
      ? raw.replace(/\s|-/g, "")
      : "+" + digits;
  }

  if (!normalized || !/^\+251[79]\d{8}$/.test(normalized)) {
    return {
      ok: false,
      error:
        "Invalid Ethiopian mobile format. Use 07/09xxxxxxxx or +2517/9xxxxxxxx.",
    };
  }

  return { ok: true, value: normalized };
}

/** Quick boolean validity check */
export function isValidEthiopianMobile(input) {
  return normalizeEthiopianMobile(input).ok;
}
